import type { ParsedUrlQuery } from "querystring"

export function parsedUrlQueryToURLSearchParams(
  query: ParsedUrlQuery,
  searchParams = new URLSearchParams()
): URLSearchParams {
  Object.entries(query).forEach(([key, values]) => {
    if (!values || values.length === 0) {
      searchParams.delete(key)
    } else if (!Array.isArray(values)) {
      searchParams.set(key, values)
    } else {
      searchParams.delete(key)
      values.forEach(value => {
        searchParams.append(key, value)
      })
    }
  })

  return searchParams
}
